module.exports = __webpack_public_path__ + "static/media/doc.e6d67415.png";